// src/App.jsx
import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useAppDispatch, useAppSelector } from './hooks/useAppDispatch.js'
import { fetchGlobalConfig } from './redux/slices/globalComponentsSlice.js'
import { initializeAuth } from './redux/slices/authSlice.js'
import PublicRoutes from './routes/PublicRoutes.jsx'
import AdminRoutes from './routes/AdminRoutes.jsx'
import { ErrorBoundary } from './components/common/ErrorBoundary.jsx'

function App() {
    const dispatch = useAppDispatch()
    const { loading } = useAppSelector((state) => state.global)

    useEffect(() => {
        // Initialize auth state from localStorage
        dispatch(initializeAuth())

        // Then fetch global config
        dispatch(fetchGlobalConfig())
    }, [dispatch])

    if (loading) {
        return (
            <div className="page-loader min-h-screen bg-black flex flex-col items-center justify-center from-green-50 to-amber-50">
                <div style={{ display: "flex", gap: "5px" }} className="flex mt-8 space-x-2">
                    {[0, 1, 2].map((i) => (
                        <motion.div
                            key={i}
                            className="h-3 w-3 bg-green-400 rounded-full"
                            animate={{ y: [0, -10, 0], opacity: [0.5, 1, 0.5] }}
                            transition={{
                                duration: 1.5,
                                repeat: Infinity,
                                delay: i * 0.2,
                                ease: "easeInOut"
                            }}
                        />
                    ))}
                </div>
            </div>
        )
    }

    return (
        <ErrorBoundary>
            <div className="App">
                <Routes>
                    <Route path="/*" element={<PublicRoutes />} />
                    <Route path="/admin/*" element={<AdminRoutes />} />
                </Routes>
            </div>
        </ErrorBoundary>
    )
}

export default App